// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    GeWhiteListRequestModel,
    GeWhitelistAddPatientRequestModel,
    GovernmentExclusionWhiteListAddPatientResponse,
    GovernmentExclusionWhiteListIsPatientWhiteListedSearchResponse,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeGovernmentExclusionApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param geWhitelistAddPatientRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async whiteListAddPatient (geWhitelistAddPatientRequestModel: GeWhitelistAddPatientRequestModel, xProgramId?: string): Promise<AxiosResponse<GovernmentExclusionWhiteListAddPatientResponse>> {
        const _url_ = '/edge/governmentExclusion/WhiteList/addPatient';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'geWhitelistAddPatientRequestModel' is not null or undefined
        if (geWhitelistAddPatientRequestModel === null || geWhitelistAddPatientRequestModel === undefined) {
            throw new Error('Required parameter geWhitelistAddPatientRequestModel was null or undefined when calling whiteListAddPatient.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(geWhitelistAddPatientRequestModel, "GeWhitelistAddPatientRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<GovernmentExclusionWhiteListAddPatientResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "GovernmentExclusionWhiteListAddPatientResponse");
        }
        return response;
    }
    /**
     * 
     * @param geWhiteListRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async whiteListIsPatientWhiteListedSearch (geWhiteListRequestModel: GeWhiteListRequestModel, xProgramId?: string): Promise<AxiosResponse<GovernmentExclusionWhiteListIsPatientWhiteListedSearchResponse>> {
        const _url_ = '/edge/governmentExclusion/WhiteList/isPatientWhiteListedSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'geWhiteListRequestModel' is not null or undefined
        if (geWhiteListRequestModel === null || geWhiteListRequestModel === undefined) {
            throw new Error('Required parameter geWhiteListRequestModel was null or undefined when calling whiteListIsPatientWhiteListedSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(geWhiteListRequestModel, "GeWhiteListRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<GovernmentExclusionWhiteListIsPatientWhiteListedSearchResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "GovernmentExclusionWhiteListIsPatientWhiteListedSearchResponse");
        }
        return response;
    }
    /**
     * 
     * @param geWhiteListRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async whiteListRemovePatient (geWhiteListRequestModel: GeWhiteListRequestModel, xProgramId?: string): Promise<AxiosResponse<GovernmentExclusionWhiteListAddPatientResponse>> {
        const _url_ = '/edge/governmentExclusion/WhiteList/removePatient';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'geWhiteListRequestModel' is not null or undefined
        if (geWhiteListRequestModel === null || geWhiteListRequestModel === undefined) {
            throw new Error('Required parameter geWhiteListRequestModel was null or undefined when calling whiteListRemovePatient.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(geWhiteListRequestModel, "GeWhiteListRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<GovernmentExclusionWhiteListAddPatientResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "GovernmentExclusionWhiteListAddPatientResponse");
        }
        return response;
    }
}
